module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-left-white-tall-26c3257759f10b055250cec79adf5751.png";